module.exports = "<div class=\"top_nav\">\n    <div class=\"nav_menu\">\n        <nav>\n            <div class=\"nav toggle nav-hamburger\">\n                <menu-resizer></menu-resizer>\n            </div>\n\n            <ul class=\"nav navbar-nav navbar-right\">\n                <li>\n                    <a id=\"logout-button\" (click)=\"logout()\">\n                        <i class=\"fa fa-sign-out\"></i>\n                    </a>\n                </li>\n            </ul>\n        </nav>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/modules/space/top_bar/top.bar.template.html
// module id = 889
// module chunks = 0